import { createSelector } from 'reselect'
import entryDataSelector from './entryDataSelector'

const viewPropertiesSelector = createSelector(
    entryDataSelector,
    (entryData): Record<string, string> [] => entryData.viewProperties,
)

export default viewPropertiesSelector
